'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var namespace = exports.namespace = 'rs';
var NOTICE_TYPES = exports.NOTICE_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
};

var PLACEMENT_TYPES = exports.PLACEMENT_TYPES = {
  TOPLEFT: 'topLeft',
  TOPRIGHT: 'topRight',
  BOTTOMLEFT: 'bottomLeft',
  BOTTOMRIGHT: 'bottomRight'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-notification/lib/constants/index.js
// module id = 322
// module chunks = 0